// audio
import audio from '../audio/audio.m.css';
// backview
import backview from './backview/backview.m.css';
import accordion2 from './base-widgets/accordion2.m.css';
import slidingpane from '../base-widgets/sliding-pane.m.css';
// base-widgets
import tabcontainer from '../base-widgets/tab-container.m.css';
import statusicon from '../book-widgets/status-icon.m.css';
import topicaccordion from '../book-widgets/topicaccordion.m.css';
import topicgroup from './book-widgets/topicgroup.m.css';
// book-widgets
import topicpage from './book-widgets/topicpage.m.css';
// card
import expanded from '../card/expanded.m.css';
import tgf from '../card/tgf.m.css';
// dojo
// import button from '../dojo/button.m.css';
import checkbox from '../dojo/checkbox.m.css';
import icon from '../dojo/icon.m.css';
import label from '../dojo/label.m.css';
import loadingIndicator from '../dojo/loading-indicator.m.css';
import radio from '../dojo/radio.m.css';
import tooltip from '../dojo/tooltip.m.css';
import carouselview from '../explore-view/carousel-view.m.css';
import chooser from '../explore-view/chooser.m.css';
// explore-view widgets
import contentorder from '../explore-view/content-order.m.css';
import navcard from '../explore-view/nav-card.m.css';
// glossary
import glossary from '../glossary/glossary.m.css';
import landingpagegeneral from '../landing-page/general.m.css';
// landing-page
import welcomeview from '../landing-page/welcome-view.m.css';
import content from '../lcc-app/content.m.css';
import footer from './lcc-app/footer.m.css';
// lcc-app
import heading from './lcc-app/heading.m.css';
import splash from './lcc-app/splash.m.css';
// lcc-rcs
import document from '../lcc-rcs/document.m.css';
// learning-activity
import activity from '../learning-activity/activity.m.css';
// prepost-viz
import prepost from '../prepost-viz/prepost-viz.m.css';
import progress from '../prepost-viz/progress-viz.m.css';
// quiz-widgets
import discussion from '../quiz-widgets/discussion.m.css';
import flashcard from './quiz-widgets/flashcard.m.css';
import mcquestion from './quiz-widgets/mcquestion.m.css';
import pretestreview from './quiz-widgets/pretest-review.m.css';
import prometricreview from './quiz-widgets/prometric-review.m.css';
import prometric from './quiz-widgets/prometric.m.css';
import questionfeedback from './quiz-widgets/questionfeedback.m.css';
import quizfolder from './quiz-widgets/quizfolder.m.css';
import singlestep from '../quiz-widgets/singlestep.m.css';
import drawer from '../table-of-contents/drawer.m.css';
// table-of-contents
import toc from '../table-of-contents/toc.m.css';
import trigger from '../table-of-contents/trigger.m.css';
//
import msurvVariant from '../variants/msurv1.m.css';
// video
import video from '../video/video.m.css';

import dojoProgress from './dojo/progress.m.css';

export default {
	theme: {
		// dojo
		// '@dojo/widgets/button': button,
		'@dojo/widgets/checkbox': checkbox,
		'@dojo/widgets/label': label,
		'@dojo/widgets/icon': icon,
		'@dojo/widgets/tooltip': tooltip,
		'@dojo/widgets/progress': dojoProgress,
		'@dojo/widgets/radio': radio,
		'@dojo/widgets/loading-indicator': loadingIndicator,
		// glossary
		'glossary/glossary': glossary,
		// backview
		'backview/backview': backview,
		// card
		'card/expanded': expanded,
		'card/tgf': tgf,
		// learning-activity
		'learning-activity/activity': activity,
		// audio
		'audio/audio': audio,
		// video
		'video/video': video,
		// lcc-app
		'lcc-app/heading': heading,
		'lcc-app/content': content,
		'lcc-app/splash': splash,
		'lcc-app/footer': footer,
		// lcc-rcs
		'lcc-rcs/document': document,
		// base-widgets
		'base-widgets/tab-container': tabcontainer,
		'base-widgets/accordion2': accordion2,
		'base-widgets/sliding-pane': slidingpane,
		// book-widgets
		'book-widgets/topicpage': topicpage,
		'book-widgets/topicgroup': topicgroup,
		'book-widgets/topicaccordion': topicaccordion,
		'book-widgets/status-icon': statusicon,
		// prepost-viz
		'prepost-viz/prepost-viz': prepost,
		'prepost-viz/progress-viz': progress,
		// table-of-contents
		'table-of-contents/toc': toc,
		'table-of-contents/trigger': trigger,
		'table-of-contents/drawer': drawer,
		// quiz-widgets
		'quiz-widgets/discussion': discussion,
		'quiz-widgets/flashcard': flashcard,
		'quiz-widgets/mcquestion': mcquestion,
		'quiz-widgets/pretest-review': pretestreview,
		'quiz-widgets/prometric-review': prometricreview,
		'quiz-widgets/prometric': prometric,
		'quiz-widgets/questionfeedback': questionfeedback,
		'quiz-widgets/singlestep': singlestep,
		'quiz-widgets/quizfolder': quizfolder,
		// landing-page
		'landing-page/welcome-view': welcomeview,
		'landing-page/general': landingpagegeneral,
		// explore-view widgets
		'explore-view/content-order': contentorder,
		'explore-view/carousel-view': carouselview,
		'explore-view/chooser': chooser,
		'explore-view/nav-card': navcard
	},
	variants: {
		msurv1: msurvVariant
	}
};
